(ns shared.core.components.tooltip
  (:require [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.components.interactive :refer [interactive]]
            ["tippy.js" :as tippy]
            [clojure.string :as s]))

(style/add-css [".tippy-box[data-theme='novo-tippy']" {:background-color (style/color :gray :shade-8)
                                                       :padding 0
                                                       :pointer-events :visible}]
               [".tippy-box[data-theme='novo-tippy'] .tippy-arrow" {:color (style/color :gray :shade-8)
                                                                    :z-index -1}]
               [".tippy-box[data-theme='novo-tippy'] .tippy-content" {:border-radius "3px"
                                                                      :color (style/color :white :base)
                                                                      :overflow :hidden}]
               [".tippy-box[data-theme='novo-tippy'] .tippy-content *" {:color (style/color :white :base)}]

               ;; light theme
               [".tippy-box[data-theme='novo-tippy-light']" {:background-color (style/color :gray :shade-13)
                                                             :padding 0
                                                             :pointer-events :visible}]
               [".tippy-box[data-theme='novo-tippy-light'] .tippy-arrow" {:color (style/color :gray :shade-13)
                                                                          :z-index -1}]

               ;; dark theme
               ["#app[data-theme='dark'] ~ [data-tippy-root] .tippy-box[data-theme='novo-tippy']" {:background-color (style/dark-color :surface :darker-1)}]
               ["#app[data-theme='dark'] ~ [data-tippy-root] .tippy-box[data-theme='novo-tippy'] .tippy-arrow" {:color (style/dark-color :surface :darker-1)}]

               ;; transparent theme — lets the tooltip content (e.g. a recharts
               ;; tooltip-panel on hover) supply all of its own styling
               [".tippy-box[data-theme='transparent']"
                {:background-color :transparent
                 :box-shadow :none}]
               [".tippy-box[data-theme='transparent'] .tippy-content"
                {:padding 0}])

(re/reg-event-db
  :tippy/hide-all re/middleware
  (fn [db]
    (tippy/hideAll)
    db))

(defn actual-tooltip [{:keys [tooltip-content tooltip-container-style placement show-on-click? interactive? hover?* append-to
                              arrow? max-width on-show on-shown on-hide on-hidden light-theme? style theme? id
                              show-on-create? offset theme distance]
                       :or {placement :bottom
                            arrow? true
                            max-width 350
                            theme? true}}]
  (let [id (or id (gensym "tippy-"))
        container-id (gensym "tippy-container-")
        tooltip-root* (atom nil)
        build-tooltip-content #(when-let [cont (.getElementById js/document container-id)]
                                 (let [cmp (into [:div {:style (merge {:color (style/color :white :base)
                                                                       :padding "7px 8px"}
                                                                      tooltip-container-style)}]
                                                 [%])]
                                   (if re/render-root
                                     (let [root (or @tooltip-root*
                                                    (reset! tooltip-root* (re/create-root cont)))]
                                       (re/render-root root cmp))
                                     (re/render cmp cont))))]
    (re/create-class
      {:component-did-mount #(let [node (.createElement js/document "div")]
                               (when tooltip-content
                                 (.setAttribute node "id" container-id)
                                 (.appendChild (.-body js/document) node)
                                 (build-tooltip-content tooltip-content)
                                 (when-let [cont (.getElementById js/document container-id)]
                                   (.default tippy
                                             (str "#" id)
                                             (clj->js (cond-> {:content cont
                                                               :theme (when theme?
                                                                        (cond
                                                                          theme
                                                                          theme

                                                                          light-theme?
                                                                          "novo-tippy-light"

                                                                          :else
                                                                          "novo-tippy"))
                                                               :maxWidth max-width
                                                               :placement (name placement)
                                                               ;:showOnCreate true ;; Can be used to debug styling (forces to show immediately)
                                                               :allowHTML true}
                                                              show-on-create? (assoc :showOnCreate true)
                                                              style (assoc :style style)
                                                              offset (assoc :offset offset)
                                                              distance (assoc :distance distance)
                                                              (false? arrow?) (assoc :arrow false)
                                                              append-to (assoc :appendTo append-to)
                                                              on-show (assoc :onShow on-show)
                                                              on-shown (assoc :onShown on-shown)
                                                              on-hide (assoc :onHide on-hide)
                                                              on-hidden (assoc :onHidden on-hidden)
                                                              hover?* (assoc :onShow (fn []
                                                                                       (reset! hover?* true)
                                                                                       (when on-show (on-show)))
                                                                             :onShown (fn []
                                                                                        (reset! hover?* true)
                                                                                        (when on-shown (on-shown)))
                                                                             :onHidden (fn []
                                                                                         (reset! hover?* false)
                                                                                         (when on-hidden (on-hidden))))
                                                              show-on-click? (assoc :trigger "click")
                                                              interactive? (assoc :interactive true)))))))
       :component-will-unmount #(do
                                  (when-let [root @tooltip-root*]
                                    (try (re/unmount-root root) (catch :default _ nil))
                                    (reset! tooltip-root* nil))
                                  (try
                                    (.removeChild js/document (.getElementById js/document container-id))
                                    (catch :default e nil))
                                  (when-let [inst (some-> (js/document.querySelector (str "#" id)) (.-_tippy))]
                                    (.destroy inst)))
       :component-did-update (fn [this]
                               (when (some-> (js/document.querySelector (str "#" id)) (.-_tippy))
                                 (build-tooltip-content (:tooltip-content (re/props this)))))
       :reagent-render (fn [{:keys [target-content style]}]
                         [:div {:id id
                                :style style
                                ;; When click-triggered, tippy's own click listener on this
                                ;; reference fires to toggle the menu; stopping propagation here
                                ;; keeps the click from bubbling to (and toggling) a parent
                                ;; row/handler without preventing tippy from opening.
                                :on-click (when show-on-click?
                                            #(.stopPropagation %))}
                          target-content])})))

(defn tooltip [_]
  (let [non-interactive-feature-disabled?- (re/subscribe [:core/feature-disabled?- :tooltip/not-interactive])]
    (fn [{:keys [interactive? target-content style] :as args}]
      (if (and @non-interactive-feature-disabled?- (not interactive?))
        [:div {:style style} target-content]
        [actual-tooltip args]))))
